import React from 'react';
import {
    Banner,
    Text
} from '@shopify/polaris';
import { AppContext } from './AppContext';

export function RequiredPermissionsWarning(props) {

    const appContext = React.useContext(AppContext);
    var missing = [];

    if (props.requiredPermissions.includes("products") &&
        !appContext.scopes.includes("write_products")) {
        missing.push("products");
    }

    if (props.requiredPermissions.includes("customers") &&
        !appContext.scopes.includes("write_customers")) {
        missing.push("customers");
    }

    if (props.requiredPermissions.includes("orders") &&
        !appContext.scopes.includes("write_orders")) {
        missing.push("orders");
    }

    if (props.requiredPermissions.includes("fulfillmentOrders") &&
        !appContext.scopes.includes("read_assigned_fulfillment_orders")) {
        missing.push("fulfillmentOrders");
    }

    if (missing.length === 0) {
        return null;
    }

    const addPermission = () => {
        appContext.requestAdditionalPermissions(props.requiredPermissions);
    }

    return (
        <Banner title='Required permissions missing!'
            status="critical"
            action={{ content: 'Add Permissions', onAction: addPermission }}>
            <p>
                The app currently has no access to data required by this functionality.
            </p>
            <p>Required data: <Text as="span" fontWeight='bold'>{missing.join(", ")}</Text> </p>
            <br/>
            <p>
                Please click the button to allow the app to access required data so that you can use this functionality.
            </p>
        </Banner>
    );
}